import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=611aa70c&scoped=true"
import script from "./PositionForm.vue?vue&type=script&lang=js"
export * from "./PositionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611aa70c",
  null
  
)

export default component.exports